module.exports = __webpack_public_path__ + "static/media/2@3x.44ed8eed.png";